import React from "react"
// react component for creating dynamic tables
import ReactTable, {ReactTableDefaults} from "react-table"
import {connect} from 'react-redux'
import moment from "moment-timezone";
import { CSVLink } from "react-csv"
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"
//import TextField from "@material-ui/core/TextField";
// @material-ui/icons
import DonutLarge from "@material-ui/icons/DonutLarge";
// core components
import GridContainer from "components/Grid/GridContainer.jsx"
import GridItem from "components/Grid/GridItem.jsx"
import Card from "components/Card/Card.jsx"
import CardBody from "components/Card/CardBody.jsx"
import CardIcon from "components/Card/CardIcon.jsx"
import CardHeader from "components/Card/CardHeader.jsx"
import LinearProgress from '@material-ui/core/LinearProgress';

import FormControl from "@material-ui/core/FormControl";
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Datetime from "react-datetime";
import {sum} from 'lodash'


import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx"

import {
  ibReportSummaryFetch,
  ibReportSummaryCsv
} from 'actions/ibReports'
import {
  profileFilter,
  profilesAvailableFetch
} from 'actions/profiles'
import {
  ibTreeAvalableFetch
} from 'actions/ibTrees'
import selectStyles from "assets/jss/material-dashboard-pro-react/customSelectStyle";
import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import Button from "components/CustomButtons/Button.jsx";

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  datepickerLabel: {
    top: '-20px',
    left: '0',
    position: 'absolute',
    color: 'rgba(0, 0, 0, 0.26) !important',
    padding: '0',
    fontSize: '14px',
    fontWeight: '400',
    //textTransform: 'uppercase',
    lineHeight: '1'
  },
  datepickerText: {
    fontSize: '14px !important',
    paddingTop: '10px !important',
  },
  tableCell: {
    width: '120px',
  },
  cellRight: {
    textAlign: 'right'
  },
  line: {
    borderTop: '2px solid transparent',
    width: '90%',
    position: 'absolute',
    bottom: '-15px'
  }
};

class List extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      from: moment.tz(moment(new Date()).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').subtract(2,'day').format(),
      to: moment.tz(moment(new Date()).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').subtract(1,'day').format(),
			includeChildren: true,
      showIncludeChildren: true,
      profileId: 0,
      csv: ''
		}

  }
  csvLink = React.createRef()
	handleChange(e, filter){
    let state = this.state
    let value = filter === 'from' || filter === 'to' ? e : e.target.value
    if(filter === 'includeChildren'){
      value = !this.state.includeChildren
    }
    
    let includeChildren = this.state.includeChildren
    let showIncludeChildren = this.state.showIncludeChildren
    // showIncludeChildren
    this.props.ibTreeAvalableFetch({profileId: filter === 'profileId' ? value : state.profileId})
      .then((tree) => {
      if(tree.length <= 1) {

        includeChildren = false
        showIncludeChildren = false

      } else {

        includeChildren = true
        showIncludeChildren = true

      }
      state[filter] = value
      this.setState({...state});

      if (filter === 'profileId') {

        this.setState({
          ...state,
            includeChildren: includeChildren,
            showIncludeChildren: showIncludeChildren,
        },() => this.fetchReport());
      
      }

    })
  }
  fetchReport(){
    const{from, to, includeChildren, profileId} = this.state
    
    let fromFormat = moment.tz(moment(from).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').subtract(1,'day').format();
    let toFormat = moment.tz(moment(to).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').format();
    
    const params = {
      from: Date.parse(fromFormat),
      to: Date.parse(toFormat),
      includeChildren
    }

    if(profileId !== 0)
      params.profileId = profileId

    this.props.fetch(params)
  }
	componentDidMount(){
		this.props.profileFilter({size: 10000})
		this.props.profilesFetch().then((e) => {
      let fromDate = moment.tz(moment(new Date()).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').subtract(2,'day').format()
      let toDate = moment.tz(moment(new Date()).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').subtract(1,'day').format()
      
      let profile = e.content && e.content.length !== 0 ? e.content[0].profileId : 0
      let includeChildren = true
      let showIncludeChildren = true
      //if no sub ibs set includeChildren false
      if(profile !== 0){

        this.props.ibTreeAvalableFetch({profileId: profile}).then((tree) => {

          if(tree.length === 1) {
            includeChildren = false
            showIncludeChildren = false
          }
          this.setState({
            profileId: profile,
            includeChildren: includeChildren,
            showIncludeChildren: showIncludeChildren,
            from: fromDate,
            to: toDate
          },() => this.fetchReport())
        })
        
      }
      
    })
  }

  ValidDate( current ){
      let minDate = moment('2019-07-22 00:00:00');
      
      return current >= minDate;
  }

  exportCsv(){
    const{from, to, includeChildren, profileId} = this.state

    let fromFormat = moment.tz(moment(from).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').subtract(1,'day').format();
    let toFormat = moment.tz(moment(to).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').format();
    
    const params = {
      from: Date.parse(fromFormat),
      to: Date.parse(toFormat),
      includeChildren
    }
    if(profileId !== 0)
      params.profileId = profileId
    this.props.ibReportSummaryCsv(params).then((e) => {
      this.setState({csv: e},() => this.csvLink.current.link.click())
    })
  }
	renderFilters(){
		const {classes, profiles} = this.props
    const {profileId} = this.state
    const fromDate = this.state.from
      ? moment(this.state.from).startOf('day').format('YYYY-MM-DD')
      : ''

    const toDate = this.state.to
      ? moment(this.state.to).endOf('day').format('YYYY-MM-DD')
      : ''

    // const tomorrow = moment.utc(new Date()).add(1,'days').endOf('day')
    // const valid = (current) => {
    //   return current.isBefore(tomorrow)
    // }
    
		return (
			<GridContainer style={{marginBottom: '30px'}}>
        <GridItem xs={2}>
          <FormControl
            fullWidth
            className={classes.selectFormControl}
          >
            <InputLabel htmlFor="profileId" className={classes.selectLabel} >
              Profile
            </InputLabel>
            <Select
              value={profileId}
              MenuProps={{
                className: classes.selectMenu
              }}
              classes={{
                select: classes.select
              }}
              inputProps={{
                onChange: (event) => this.handleChange(event, "profileId"),
                id: "profileId",
                name: "profileId"
              }}>
              {profiles
                .map((e) => (
                  <MenuItem
                    key={e.profileId}
                    classes={{
                      root: classes.selectMenuItem
                    }}
                    value={e.profileId}>
                    {e.profileId}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          
        </GridItem>
			
        <GridItem xs={3}>
            
            <FormControl className={classes.selectFormControl} style={{paddingTop: '5px'}} fullWidth>
              <InputLabel className={classes.datepickerLabel}>Start Date *</InputLabel>
              <Datetime
                timeFormat={false}
                dateFormat={'YYYY-MM-DD'}
                inputProps={{placeholder: 'yyyy/mm/dd'}}
                utc={true}
                isValidDate={ this.ValidDate }
                locale={moment.locale('en',{week: {
                  dow: 1
                }})}
                //isValidDate={valid}
                onChange={(event) => this.handleChange(event, "from")}
                value={fromDate}
                className={classes.select + ' ' + classes.datepickerText}
              />
            </FormControl>
          {/* <FormControl
            fullWidth
            className={classes.selectFormControl}
          >
            <TextField
              id="from"
              label="Start Date (NY timezone)"
              type="date"
              onChange={(event) => this.handleChange(event, "from")}
              value={fromDate}
              className={classes.textField}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </FormControl> */}
        </GridItem>

        <GridItem xs={3}>
          <FormControl className={classes.selectFormControl} style={{paddingTop: '5px'}} fullWidth>
              <InputLabel className={classes.datepickerLabel}>To Date *</InputLabel>
              <Datetime
                timeFormat={false}
                utc={true}
                //isValidDate={valid}
                dateFormat={'YYYY-MM-DD'}
                isValidDate={ this.ValidDate }
                locale={moment.locale('en',{week: {
                  dow: 1
                }})}
                inputProps={{placeholder: 'yyyy/mm/dd'}}
                onChange={(event) => this.handleChange(event, "to")}
                value={toDate}
                className={classes.select + ' ' + classes.datepickerText}
              />
          </FormControl>
          {/* <FormControl
            fullWidth
            className={classes.selectFormControl}
          >
            <TextField
              id="to"
              label="To Date"
              type="date"
              onChange={(event) => this.handleChange(event, "to")}
              value={toDate}
              className={classes.textField}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </FormControl> */}
        </GridItem>
        {this.state.showIncludeChildren && (
          <GridItem xs={2}>
            <FormControlLabel
              style={{marginTop:'15px'}}
              control={
                <Checkbox
                  color="default"
                  checked={this.state.includeChildren}
                  onChange={(event) => this.handleChange(event, "includeChildren")}
                />
              }
              classes={{
                label: classes.linkFooter
              }}
              label="Including SubIBs"
            />
          </GridItem>
        )}
        <GridItem xs={2}>
          <div style={{float:'right'}}>
            <Button onClick={() => this.fetchReport()} className={classes.submit} color="success">Search</Button>
          </div>
        </GridItem>
        
				
			</GridContainer>
		)
  }
  setPageSizeOptions(data){
    const pageSizeOptions = [10]
    if(data.length > 10) {
      pageSizeOptions.push(20)
    }
    if(data.length > 20) {
      pageSizeOptions.push(50)
    }
    if(data.length > 50) {
      pageSizeOptions.push(100)
    }

    Object.assign(ReactTableDefaults, {
      pageSizeOptions: pageSizeOptions,
    })
    return pageSizeOptions
  }
  render() {
    const { classes, report:{data,additionalData}, reports } = this.props
    this.setPageSizeOptions(data)

    return (
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary" icon>
              <CardIcon color="primary">
                <DonutLarge />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>My Reports</h4>
            </CardHeader>
            <CardBody>
							{this.renderFilters()}
							{(reports.isFetching) ?
              (<LinearProgress color="primary"/>)
              :
              (<div>
              <ReactTable
                data={data}
                // onPageSizeChange={(pageSize, pageIndex) => {
                //   console.log(pageSize)
                // }}
                columns={[
                  {
                    id: '1',
                    sortable: true,
                    Header: () => <div><span>{'Profile Name'}</span><hr className={classes.line} /></div>,
                    width: 120,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    headerClassName: 'customHeader',
                    accessor: d => d[1]
                    ,
                    Footer: (
                      <span></span>
                    )
                  },
                  {
                    id: '2',
                    Header: () => <div><span>{'Date'}</span><hr className={classes.line} /></div>,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    width: 100,
                    headerClassName: 'customHeader',
                    accessor: d => d[2],
                    Footer: (
                      data.length !== 0 ? <strong>Total (USD)</strong> : ''
                    )
                  },
                  {
                    id: '3',
                    Header: () => <div className={classes.tableCell}><span>{'Volume (USD)'}</span><hr className={classes.line} /></div>,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    //className: classes.cellRight,
                    width: 120,
                    headerClassName: 'customHeader',
                    accessor: d => (Math.round(d[3] * 100) / 100).toLocaleString(),
                    Footer: (
                      additionalData ? <span>{(Math.round(Number(additionalData.total_volume) * 100) / 100).toLocaleString()}</span> : ''
                    )
                  },
                  {
                    id: '4',
                    Header: () => <div className={classes.tableCell}><span style={{width: '80px'}}>{'Number of clients'}</span><hr className={classes.line} /></div>,
                    width: 120,
                    headerClassName: 'customHeader',
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    accessor: d => d[4],
                    Footer: (
                      additionalData ? <span>{additionalData.distinct_clients}</span> : ''
                    )
                  },
                  {
                    id: '5',
                    Header: () => <div className={classes.tableCell}><span style={{width: '80px'}}>{'Number of Trading Accounts'}</span><hr className={classes.line} /></div>,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    width: 120,
                    headerClassName: 'customHeader',
                    accessor: d => <span style={{width: '90px'}}>{d[5]}</span>,
                    Footer: (
                      additionalData ? <span>{additionalData.distinct_accounts}</span> : ''
                    )
                  },
                  {
                    id: '6',
                    Header: () => <div className={classes.tableCell}><span>{'Markup Rebate (USD)'}</span><hr className={classes.line} /></div>,
                    width: 120,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    //className: classes.cellRight,
                    headerClassName: 'customHeader',
                    accessor: d => (Math.round(d[6] * 100) / 100).toLocaleString(),
                    Footer: (
                      additionalData ? <span>{(Math.round(Number(additionalData.total_markup) * 100) / 100).toLocaleString()}</span> : ''
                    )
                  },
                  {
                    id: '7',
                    Header: () => <div className={classes.tableCell}><span>{'Spread Rebate (USD)'}</span><hr className={classes.line} /></div>,
                    width: 120,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    //className: classes.cellRight,
                    headerClassName: 'customHeader',
                    accessor: d => (Math.round(d[7] * 100) / 100).toLocaleString(),
                    Footer: (
                      additionalData ? <span>{(Math.round(Number(additionalData.total_spread) * 100) / 100).toLocaleString()}</span> : ''
                    )
                  },
                  {
                    id: '8',
                    Header: () => <div className={classes.tableCell}><span  style={{width: '95px'}}>{'Commission Rebate (USD)'}</span><hr className={classes.line} /></div>,
                    width: 120,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    //className: classes.cellRight,
                    headerClassName: 'customHeader',
                    accessor: d => (Math.round(d[8] * 100) / 100).toLocaleString(),
                    Footer: (
                      additionalData ? <span>{(Math.round(Number(additionalData.total_commission) * 100) / 100).toLocaleString()}</span> : ''
                    )
                  },
                  {
                    id: '9',
                    Header: () => <div className={classes.tableCell}><span style={{width: '87px'}}>{'Rebate on Shares (USD)'}</span><hr className={classes.line} /></div>,
                    width: 120,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    //className: classes.cellRight,
                    headerClassName: 'customHeader',
                    accessor: d => Math.round(d[9] * 100) / 100,
                    Footer: (
                      data.length !== 0 ? <span>{Math.round(sum(data.map((row) => Number(row[9]))) * 100) / 100}</span> : ''
                    )
                  },
                  {
                    id: '10',
                    Header: () => <div className={classes.tableCell}><span>{'Total Rebate (USD)'}</span><hr className={classes.line} /></div>,
                    width: 120,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    //className: classes.cellRight,
                    headerClassName: 'customHeader',
                    accessor: d => (Math.round(d[10] * 100) / 100).toLocaleString(),
                    Footer: (
                      additionalData ? <span>{(Math.round(Number(additionalData.total_total) * 100) / 100).toLocaleString()}</span> : ''
                    )
                  }
                ]}
                defaultPageSize={10}
                // showPaginationTop
                // showPaginationBottom={false}
                className="-striped -highlight"
              />
              
              <div style={{float:'left', marginTop: '20px', width:'100%'}}>
                <span>* Trading day starts at 5pm New York timezone.</span>
              </div>
              </div>)}
              
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12}>
          <div style={{float:'right'}}>
            <Button onClick={() => this.exportCsv()} className={classes.submit} color="success">Export CSV</Button>
            <CSVLink data={this.state.csv} filename={"summary-report.csv"} ref={this.csvLink} className="hidden" />
          </div>
        </GridItem>
      </GridContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  report: state.ibReports.ibSummary,
	reports: state.ibReports,
	profiles: state.profiles.list
})

const mapDispatchToProps = (dispatch) => ({
  fetch: (params) => dispatch(ibReportSummaryFetch(params)),
  ibReportSummaryCsv: (params) => dispatch(ibReportSummaryCsv(params)),
	profilesFetch: () => dispatch(profilesAvailableFetch()),
  profileFilter: (filter) => dispatch(profileFilter(filter)),
  ibTreeAvalableFetch: (data) => dispatch(ibTreeAvalableFetch(data))
})

export default withStyles({...styles, ...selectStyles, ...extendedFormsStyle})(connect(mapStateToProps, mapDispatchToProps)(List));



// WEBPACK FOOTER //
// ./src/views/StatementSummaryReport/List.jsx